import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumberOfChargingStationsComponent } from './number-of-charging-stations.component';
import { NumberInputModule } from '../../../../../../component-lib/components/forms/number-input/number-input.module';

@NgModule({
  declarations: [NumberOfChargingStationsComponent],
  exports: [NumberOfChargingStationsComponent],
  imports: [CommonModule, NumberInputModule],
})
export class NumberOfChargingStationsModule {}
